import React from 'react';
import './MobileMenu.css';

const MobileMenu = () => {
  return (
    <div className="mobile-menu">
      {/* Mobile menu placeholder */}
    </div>
  );
};

export default MobileMenu;
